import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { by } from '../common/routerAccess';
import { Auth } from '../helper/api/';
import { withRouter } from 'react-router-dom';

export function isAccessTo(is, access) {
  const tokenValid = Auth.isValid();

  if(
      (access.includes(by.ALL))
      ||
      (access.includes(by.only.VISITOR) && !is.auth && !is.admin)
      ||
      (access.includes(by.only.USER) && is.auth && tokenValid)
      ||
      (access.includes(by.only.ADMIN) && is.auth && is.admin && tokenValid)
  )
      return true;

  return false;
}

export class Dispatcher extends Component {
  static propTypes = {
    is: PropTypes.shape({
      admin: PropTypes.bool.isRequired,
      auth: PropTypes.bool.isRequired
    }),
    component: PropTypes.func,
    access: PropTypes.array.isRequired
  };

  render() {
    const access = isAccessTo(this.props.is, this.props.access);

    //access denied and is not connected -> login
    if(!access && !this.props.is.auth)
      return <Redirect to="/auth/signin"/>
    //access denied -> 404
    else if(!access)
      return <Redirect to="/404" />

    //stop propagation
    let propsComponent = Object.assign({}, this.props);
    delete propsComponent.component;
    delete propsComponent.access;
    delete propsComponent.children;
    delete propsComponent.dispatch;

    //show the page
    let MyComponent = this.props.component;
    return (<MyComponent {...propsComponent}>{this.props.children}</MyComponent>);
  }
}

/* get the authentification status */
function mapStateToProps(state) {
  return {
    is: {
      admin: state.authentification.isAdmin,
      auth: state.authentification.isAuth
    }
  };
}


export default withRouter(connect(
  mapStateToProps
)(Dispatcher));



// WEBPACK FOOTER //
// ./src/common/Dispatcher.js